import React from 'react'

import MaskedView from '@react-native-masked-view/masked-view'
import { B4, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LinearGradient } from 'expo-linear-gradient'

const MagnetTextComp = () => {
  return (
    <Stack className="">
      <MaskedView
        style={{ top: 4 }}
        maskElement={
          <B4>
            {i18n.t('magnetCrossSelling.magnetOnListing.magnetCreditCard')}
          </B4>
        }
      >
        <LinearGradient
          colors={['#E38B08', '#FFCB42', '#FFECBA', '#E79A26']}
          start={[0, 0]}
          end={[1, 0.0]}
        >
          <B4 style={{ opacity: 0 }}>
            {i18n.t('magnetCrossSelling.magnetOnListing.magnetCreditCard')}
          </B4>
        </LinearGradient>
      </MaskedView>
    </Stack>
  )
}

export default MagnetTextComp
